import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { UsageHistoryItem } from '@/modules/batches/type'

export const columns: ColumnDef<UsageHistoryItem>[] = [
	{
		accessorKey: 'playerPhone',
		header: 'เบอร์โทรผู้เล่น',
		cell: ({ row }) => (
			<span className="font-mono">{row.original.playerPhone || '-'}</span>
		),
	},
	{
		accessorKey: 'usedAt',
		header: 'วันที่ใช้งาน',
		cell: ({ row }) => (
			<span>
				{format(new Date(row.original.usedAt), 'dd/MM/yyyy HH:mm:ss', {
					locale: th,
				})}
			</span>
		),
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่บันทึก',
		cell: ({ row }) => (
			<span>
				{format(new Date(row.original.createdAt), 'dd/MM/yyyy HH:mm:ss', {
					locale: th,
				})}
			</span>
		),
	},
]
